importScripts('openhps-core.min.js'); __WEBPACK_EXTERNAL_MODULE____ = self.OpenHPS.core;